export default "__VITE_ASSET__Bk3aRBw4__"